{
    "NextrunningatLabel": "Próxima Execução em:",
    "LastrunatLabel": "Última execução em:",
    "StatuserrorLabel": "Situação\/Erro:",
    "ScheduleStatus_SectionHeader": "Estado de agendamento",
    "NAME": "ScheduleEstado"
}